module.exports = __webpack_public_path__ + "img/programs_showcase.d8395ab1.png";